import request from "@/utils/request";

export function registerUser(data){
    return request({
        url:'/system/registerUser/register',
        method: 'post',
        data: data
    })
}


// 用户头像上传
export function uploadAvatar(data) {
    return request({
      url: '/system/user/profile/avatar',
      method: 'post',
      data: data
    })
  }
  // 项目公开
  export function lpublic(dataId) {
    return request({
        url: `/mdap-private/api/v1/project/open/${dataId}`,
        method: "get",
    });
  }
  

  // 项目新增
export function projectSave(data) {
  return request({
    url: '/mdap-private/api/v1/project/save',
    method: 'post',
    data: data
  })
}

  // 我的参与新增
  export function projectjoinSave(data) {
    return request({
      url: '/mdap-private/api/v1/project/joinSave',
      method: 'post',
      data: data
    })
  }

  // 获取项目列表
  export function allProjectList(data) {
    return request({
      url: '/mdap-private/api/v1/project/allProject',
      method: 'post',
      data: data
    })
  }
  
  
// 根据项目id删除项目
export function deleteProjectList(data){
  return request({
      url:`/mdap-private/api/v1/project/deleteByIds`,
      method: 'post',
      data: data
  })
}

//我的项目列表查询
export function myProjectList(data){
  return request({
      url:`/mdap-private/api/v1/project/myProject`,
      method: 'post',
      data: data
  })
}

//我参与的项目列表查询
export function myJoinList(data){
  return request({
      url:`/mdap-private/api/v1/project/myJoin`,
      method: 'post',
      data: data
  })
}

//项目复制
export function projectcopy(data){
  return request({
      url:`/mdap-private/api/v1/project/copy`,
      method: 'post',
      data: data
  })
}

//已完结项目列表查询
export function finishedProjectList(data){
  return request({
      url:`/mdap-private/api/v1/project/finishedProject`,
      method: 'post',
      data: data
  })
}

// 根据项目id查询详情
export function queryDetailById(dataId) {
  return request({
      url: `/mdap-private/api/v1/project/selectInfoById/${dataId}`,
      method: "get",
  });
}

//项目修改
export function projectUpdata(data){
  return request({
      url:`/mdap-private/api/v1/project/update`,
      method: 'put',
      data: data
  })
}

//项目分享
export function projectShare(data){
  return request({
      url:`/mdap-private/api/v1/project/share`,
      method: 'post',
      data: data
  })
}
//分享消息同意
export function projectNewsUpdate(data){
  return request({
      url:`/mdap-private/api/v1/projectNewsRelation/agree`,
      method: 'put',
      data: data
  })
}
//根据id查询流程详情(分享)

export function projectNewsRelation(dataId){
  return request({
      url:`/mdap-private/api/v1/projectNewsRelation/selectInfoById/${dataId}`,
      method: 'get',
  })
}



//保存用户信息
export function saveUserNickName(data){
  return request({
      url:`/system/user/update/nickname`,
      method: 'put',
      params: data
  })
}

//其他四个流程
export function Processlist(data){
  return request({
      url:`/mdap-private/api/v1/process/selectList`,
      method: 'post',
      data: data
  })
}

//所有流程
export function allProcesslist(data){
  return request({
      url:`/mdap-private/api/v1/process/allProcess`,
      method: 'post',
      data: data
  })
}

//保存流程
export function saveProcess(data){
  return request({
      url:`/mdap-private/api/v1/process/save`,
      method: 'post',
      data: data
  })
}

//所有团队
export function allTeamList(data){
  return request({
      url:`/mdap-private/api/v1/team/allTeam`,
      method: 'post',
      data: data
  })
}

//模板库批量删除
export function processDeleteByIds(data){
  return request({
      url:`/mdap-private/api/v1/wfGraph`,
      method: 'delete',
      data: data
  })
}

//流程复制
export function processcopy(dataId){
  return request({
      url:`/mdap-private/api/v1/process/copy/${dataId}`,
      method: 'get',
  })
}

//流程分享
export function processshare(data){
  return request({
      url:`/mdap-private/api/v1/process/share`,
      method: 'post',
      data: data
  })
}

//流程修改
export function processUpdate(data){
  return request({
      url:`/mdap-private/api/v1/wfGraph`,
      method: 'post',
      data: data
  })
}

//消息接口
export function notification(id){
  return request({
      url:`/mdap-private/api/v1/notification/${id}`,
      method: 'get',
  })
}

// 批量全部删除
export function notificationss(data){
  return request({
      url:`/mdap-private/api/v1/notification`,
      method: 'delete',
      data: data
  })
}
//消息列表
export function notificationList(){
  return request({
      url:`/mdap-private/api/v1/notification/list`,
      method: 'get',
  })
}

//根据id删除消息
export function notificationDelete(id){
  return request({
      url:`/mdap-private/api/v1/notification/${id}`,
      method: 'delete',
  })
}

//读消息
export function notificationRead(data){
  return request({
      url:`/mdap-private/api/v1/notification/read`,
      method: 'post',
      data: data
  })
}

//新增消息
export function notificationNew(data){
  return request({
      url:`/mdap-private/api/v1/notification`,
      method: 'post',
      data: data
  })
}

//根据id查询流程详情
export function processInfoById(id){
  return request({
      url:`/mdap-private/api/v1/wfGraph/${id}`,
      method: 'get',
  })
}


//用户信息修改
export function userprivateUpdate(data){
  return request({
      url:`/system/user/profile`,
      method: 'put',
      data: data
  })
}

//查询基因表达数据
export function geoDataList(data){
  return request({
      url:`/mdap-private/api/v1/geoData/list`,
      method: 'post',
      data: data
  })
}

//消息同意
export function myFriendUpdate(data){
  return request({
      url:`/mdap-private/api/v1/friendNewsRelation/agree`,
      method: 'put',
      data: data
  })
}

//根据id查询流程详情
export function myFriendInfoById(dataId){
  return request({
      url:`/mdap-private/api/v1/friendNewsRelation/selectInfoById/${dataId}`,
      method: 'get',
  })
}


//数据空间评分
export function evaluationData(data){
  return request({
      url:`/mdap-private/api/v1/evaluation`,
      method: 'post',
      data: data
  })
}

//项目关联list
export function projectLinkList(projectId){
  return request({
      url:`/mdap-private/api/v1/project/link/${projectId}/list`,
      method: 'post',
  })
}

//根据项目id获取关联项目运行结果
export function executeResultList(projectId){
  return request({
      url:`/mdap-private/api/v1/executeResult/${projectId}/result/list`,
      method: 'get',
  })
}

//批量保存项目关联
export function projectlinkSave(data){
  return request({
      url:`/mdap-private/api/v1/project/link/list/save`,
      method: 'post',
      data: data
  })
}

//新增或修改
export function projecttoolSave(data){
  return request({
      url:`/mdap-private/api/v1/project/link`,
      method: 'post',
      data: data
  })
}

//我参与的项目列表查询
export function teamProjectList(data){
  return request({
      url:`/mdap-private/api/v1/team/teamProject`,
      method: 'post',
      data: data
  })
}

//工具参数check
export function jobsCheck(nodeId){
  return request({
      url:`/mdap-private/api/v1/jobs/${nodeId}/check/dynamic`,
      method: 'get',
  })
}

//获取数据资源三级联动数据
export function searchGwas() {
  return request({
      url: '/mdap-private/api/v1/gwas/search/params',
      method: 'get'
  })
}

//团队邀请--消息接口
export function teamNewsRelationUpload(data) {
  return request({
      url: '/mdap-private/api/v1/teamNewsRelation/agree',
      method: 'put',
      data: data
  })
}

 // 查询数据空间数据
 export function querydataSpaceList(data){
  return request({
    url:'/mdap-private/api/v1/dataSpace/list',
    method:'post',
    data: data
  })
}

//根据id查询团队邀请详情
export function teamNews(dataId) {
  return request({
      url: `/mdap-private/api/v1/teamNewsRelation/selectInfoById/${dataId}`,
      method: 'get'
  })
}

 // 数据空间分享
 export function dataSpaceShare(dataGroupType,id,receiverId,receiverName){
  return request({
    url:`/mdap-private/api/v1/dataSpace/${dataGroupType}/${id}/share`,
    method:'post',
    params:{
      receiverId,receiverName
    }
  })
}

 // 查询数据空间数据
 export function ShareConfirm(notificationId){
  return request({
    url:`/mdap-private/api/v1/dataSpace/share/${notificationId}/confirm`,
    method:'post',
  })
}

//好友添加
export function selectInfoByIdRelation(dataId) {
  return request({
      url: `/mdap-private/api/v1/friendNewsRelation/selectInfoById/${dataId}`,
      method: 'get'
  })
}

//流程消息查询
export function processRelation(dataId) {
  return request({
      url: `/mdap-private/api/v1/processNewsRelation/selectInfoById/${dataId}`,
      method: 'get'
  })
}

// 保存数据空间项目数据
export function dataSpaceSave(projectId,data){
 return request({
   url:`/mdap-private/api/v1/dataSpace/project/${projectId}/save`,
   method:'post',
   data:data
 })
}


// 根据项目id获取文件列表
export function fileProjectList(projectId){
  return request({
    url:`/mdap-private/api/v1/file/${projectId}/project/list`,
    method:'post',
  })
 }
 
//消息拒绝
export function notificationReject(id) {
  return request({
      url: `/mdap-private/api/v1/notification/${id}/reject`,
      method: 'post'
  })
}


//好友列表删除
export function friendNewsDeleteById(dataId){
  return request({
      url:`/mdap-private/api/v1/friendNewsRelation/deleteById/${dataId}`,
      method: 'get',
  })
}

//项目分享删除
export function projectNewsDeleteById(dataId){
  return request({
      url:`/mdap-private/api/v1/projectNewsRelation/deleteById/${dataId}`,
      method: 'get',
  })
}

//团队邀请删除
export function teamNewsDeleteById(dataId){
  return request({
      url:`/mdap-private/api/v1/teamNewsRelation/deleteById/${dataId}`,
      method: 'get',
  })
}

//模板库同意
export function processNewsRelationUpdata(data) {
  return request({
      url: '/mdap-private/api/v1/processNewsRelation/agree',
      method: 'put',
      data: data
  })
}

//模板库拒绝
export function processNewsDeleteById(dataId){
  return request({
      url:`/mdap-private/api/v1/processNewsRelation/deleteById/${dataId}`,
      method: 'get',
  })
}

export function dataSpaceQuote(dataGroupType,id,projectId) {
  return request({
      url: `/mdap-private/api/v1/dataSpace/${dataGroupType}/${id}/quote`,
      method: "post",
      params:{
          projectId
      }
  })
}

//根据项目id查询引用数据
export function projectReference(params){
  return request({
      url:`/mdap-private/api/v1/dataSpace/project/list`,
      method: 'post',
      data:params
  })
}

//项目新建
export function projectDataSpaceLink(data) {
  return request({
      url: `/mdap-private/api/v1/projectDataSpaceLink/saveOrUpdate/batch`,
      method: "post",
      data:data
  })
}

//删除引用数据
export function quoteDelete(projectId,dataSpaceId) {
  return request({
      url: `/mdap-private/api/v1/projectDataSpaceLink/${projectId}/${dataSpaceId}/delete`,
      method: "delete",
  })
}
//项目-分享列表
export function dataSpaceQuoteList(data) {
  return request({
      url: `/mdap-private/api/v1/project/dataSpaceQuote`,
      method: "post",
      data:data
  })
}
//项目-根据路径复制
export function fileCopyPath(data) {
  return request({
      url: `/mdap-private/api/v1/file/copy/path`,
      method: "post",
      data:data
  })
}
//项目-获取文件树
export function fileTreeList(data) {
  return request({
      url: `/mdap-private/api/v1/file/tree`,
      method: "post",
      data:data
  })
}

//根据nodeId获取日志
export function executeReqLatest(nodeId) {
    return request({
        url: `/mdap-private/api/v1/executeReq/node/${nodeId}/instanceId/latest`,
        method: "get",
    })
}

//项目-获取文件树
export function executeResultJobInstance(jobInstanceId) {
    return request({
        url: `/mdap-private/api/v1/executeResult/job/${jobInstanceId}/instance/list`,
        method: "post",
    })
}

//参数设置页面流程节点状态
export function workflowInstanceStatus(workflowId) {
    return request({
        url: `/mdap-private/api/v1/workflow/${workflowId}/node/instance/status`,
        method: "get",
    })
}

//查看下载列表
export function dlTaskLit() {
    return request({
        url: `/mdap-private/api/v1/dlTask/list`,
        method: "get",
    })
}
//查看下载
export function downloadDlTask(id) {
    return request({
        url: `/mdap-private/api/v1/dlTask/download/${id}`,
        method: "get",
    })
}
//删除下载列表
export function deletedlTask(id){
    return request({
        url:`/mdap-private/api/v1/dlTask/${id}`,
        method: 'delete',
    })
}

//查看下载
export function executeResultInstanceDownload(jobInstanceId) {
    return request({
        url: `/mdap-private/api/v1/executeResult/job/${jobInstanceId}/instance/download`,
        method: "post",
    })
}
//查询下载报告列表
export function informTplAll(id) {
    return request({
        url: `/mdap-private/api/v1/inform/tpl/all`,
        method: "get",
    })
}

//查询下载报告列表
export function informDownLoad(wfInstanceId,fileType,tplId) {
    return request({
        url: `/mdap-private/api/v1/inform/${wfInstanceId}/${fileType}/${tplId}/download`,
        method: "get",
    })
}

//查询下载报告列表
export function getRegisterUser(id) {
    return request({
        url: `/system/registerUser/activation/${id}`,
        method: "get",
    })
}